import React from "react";
import { HouseIcon } from "@phosphor-icons/react";

import { Link } from "react-router-dom";
import "./Navbar.css";
import Logo from "../../assets/image/cLogo.png";
import ThemeSwitch from '../../components/ThemeSwitch/ThemeSwitch';

const Navbar = () => {
  

  return (
    <>
      

      <div className="Navbar">
        <div className="nav-center">
          <div className="logo-chamber">
            <img src={Logo} alt="logo" className="logo" height={30} width={38.89} />
          </div>
          <div className="search-gr">
            <Link to="/" aria-label="Home">
              <HouseIcon size={32} weight="regular" className="icon" />
            </Link>
            <ThemeSwitch className="icon" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
